import React, { Component } from 'react';

import UserContext from '../../contexts/UserContext';
import ActivateForm from '../../partials/ActivateForm/ActivateForm';

import './Activate.scss';

class Activate extends Component {

	static contextType = UserContext;

	render() {
		const { signedIn } = this.context;

		return (
			<div className="Activate">
				<div className="Activate-content">
					<div className="Activate-title">
						Activate Your Device
					</div>
					<ActivateForm signedIn={signedIn} />

				</div>
			</div>
		)
	}
}

export default Activate;